import { InputMask } from "@react-input/mask";
import FieldValidationError from "../Forms/Element/FieldValidationError";

const MASCARA_CPF = "___.___.___-__";
const MASCARA_CNPJ = "__.___.___/____-__";

/**
 * Entrada de documento que aceita CPF ou CNPJ.
 *
 * Existe separado de CpfInput e CnpjInput porque a máscara aqui é variável: ela acompanha o
 * que está sendo digitado, enquanto os outros dois têm formato fixo. Usar este componente
 * onde só um dos documentos vale tiraria a garantia que a máscara fixa dá.
 *
 * É o cadastro de empresa que precisa dos dois: nem todo cliente abre pessoa jurídica, e o
 * profissional que atende como pessoa física precisa ser cadastrado do mesmo jeito.
 *
 * A troca de formato acontece no 12º dígito. Antes disso o CPF completo (11 dígitos) já foi
 * digitado inteiro no formato dele, então quem informa CPF nunca vê a máscara de CNPJ
 * aparecer no meio do caminho.
 */
const CpfCnpjInput = ({ value, ...props }) => {
    const digitos = String(value ?? "").replace(/\D/g, "");
    const mask = digitos.length <= 11 ? MASCARA_CPF : MASCARA_CNPJ;

    return (
        <>
            <InputMask
                mask={mask}
                replacement={{ _: /\d/ }}
                className="form-control input-default"
                value={value}
                {...props}
            />
            <FieldValidationError error={props.error} />
        </>
    )
}

export default CpfCnpjInput;
